var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmoji3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8896 16C32.8896 24.8364 25.7261 32 16.8896 32C8.05409 32 0.889648 24.8364 0.889648 16C0.889648 7.16444 8.05409 0 16.8896 0C25.7261 0 32.8896 7.16444 32.8896 16Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1119 17.7779C12.3392 17.7779 13.3341 16.385 13.3341 14.6668C13.3341 12.9486 12.3392 11.5557 11.1119 11.5557C9.88457 11.5557 8.88965 12.9486 8.88965 14.6668C8.88965 16.385 9.88457 17.7779 11.1119 17.7779Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 17.7779C23.8939 17.7779 24.8888 16.385 24.8888 14.6668C24.8888 12.9486 23.8939 11.5557 22.6666 11.5557C21.4393 11.5557 20.4443 12.9486 20.4443 14.6668C20.4443 16.385 21.4393 17.7779 22.6666 17.7779Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1136 23.1113H10.6692C10.1785 23.1113 9.78027 22.7139 9.78027 22.2224C9.78027 21.7308 10.1785 21.3335 10.6692 21.3335H23.1136C23.6052 21.3335 24.0025 21.7308 24.0025 22.2224C24.0025 22.7139 23.6052 23.1113 23.1136 23.1113Z",
    fill: "#664500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji3);
export default __webpack_public_path__ + "static/media/emoji3.c9079679f90f2c0fb5ccd6f5b77ccbe8.svg";
export { ForwardRef as ReactComponent };